module.exports = __webpack_public_path__ + "static/media/logo16.641a8cdc.jpg";